import React from "react";
import { toaster, Message } from "rsuite";

const ToasterComponent = ({
  placement = "topEnd", // topStart |  topEnd | topCenter | bottomStart | bottomEnd | bottomCenter
  duration = 5000, // For how much time want to show
  type, // Mandatory, values -> info | success | warining | error
  message, // Mandatory, value -> text want to show in toaster
  showIcon = true, // true | false for showing type icon
  closable = false, // true | false Option for closing toaster mesaage
  removeToaster = false,
}: {
  placement?: any;
  duration?: number;
  type: any;
  message: string;
  showIcon?: boolean;
  closable?: boolean;
  removeToaster?: boolean;
}) => {
  return (
    <>
      {removeToaster ? (
        <>{toaster.clear()}</>
      ) : (
        <>
          {toaster.push(
            <Message
              showIcon={showIcon}
              closable={closable}
              type={type}
              duration={duration}
            >
              {message}
            </Message>,
            { placement: placement }
          )}
        </>
      )}
    </>
  );
};

export default ToasterComponent;
